const PortalData = [
  {
    id: 1,
    Title: "Pre-Ph.D Subjects List and Syllabus",
    Status: "publish",
    Notification_Date: "Fri Oct 13, 2022",
    File: "/",
    Action: "/",
  },
  {
    id: 2,
    Title: "Pre-Ph.D Subjects List and Syllabus",
    Status: "publish",
    Notification_Date: "Fri Oct 13, 2022",
    File: "/",
    Action: "/",
  },
  {
    id: 3,
    Title: "Pre-Ph.D Subjects List and Syllabus",
    Status: "publish",
    Notification_Date: "Fri Oct 13, 2022",
    File: "/",
    Action: "/",
  },
  {
    id: 4,
    Title: "Pre-Ph.D Subjects List and Syllabus",
    Status: "publish",
    Notification_Date: "Fri Oct 13, 2022",
    File: "/",
    Action: "/",
  },
  {
    id: 5,
    Title: "Pre-Ph.D Subjects List and Syllabus",
    Status: "publish",
    Notification_Date: "Fri Oct 13, 2022",
    File: "/",
    Action: "/",
  },
];

export default PortalData;
